import { Breadcrumbs } from "components/breadcrumbs";
import React from "react";
import EwaiverForm from "../components/form";
import { EmailSectionItem, EwaiverCreatePayload } from "../api";
import dayjs from "dayjs";
import { useCreateEwaiver } from "../hooks/useCreateEwaiver";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const EwaiverCreatePage = () => {
  const navigate = useNavigate();

  const { createEwaiver, loading } = useCreateEwaiver();

  const handleSubmit = async (data: any) => {
    try {
      const email_section: EmailSectionItem[] = [];

      data?.event_infos?.forEach((item: any) => {
        // if (!item.status) return;

        if (item.type === "url" && item.url) {
          email_section.push({
            title_en: item.title_name_en,
            title_vi: item.title_name_vi,
            type: "url",
            value: [item.url],
            show: item.status,
          });
        }

        if (item.type === "images" && item.images?.length > 0) {
          email_section.push({
            title_en: item.title_name_en,
            title_vi: item.title_name_vi,
            type: "image",
            value: item.images,
            show: item.status,
          });
        }
      });

      const payload: EwaiverCreatePayload = {
        event_id: data?.event_id,
        is_have_online_checkin: data?.is_active,
        start_checkin_online_date: dayjs(
          data.start_date_time,
          "DD/MM/YYYY HH:mm"
        ).format("YYYY-MM-DD HH:mm:ss"),
        end_checkin_online_date: dayjs(
          data.end_date_time,
          "DD/MM/YYYY HH:mm"
        ).format("YYYY-MM-DD HH:mm:ss"),

        authorization_form_url: data?.authorization_form_url,
        disclaimer_form_url: data?.disclaimer_form_url,
        t_and_c_link: data?.t_and_c_link,
        ewaiver_banner_url: data?.banner_url,

        ewaiver_file: data?.html_url,

        waiver_sign_required: data?.ewaiver_signature_required,
        is_sent_to_authorizer: data?.send_email_to_authorizer,
        send_bib_via_email: data?.send_bib_via_email,
        is_show_send_ewaiver: data?.is_show_send_ewaiver ?? false,
        is_show_send_qrcode: data?.is_show_send_qrcode ?? false,

        is_change_pickup_method: data?.change_pickup_method,
        number_of_times_change_pickup: data?.max_pickup_method,

        is_change_authorized_info: data?.change_authorized_info,
        number_of_times_update_authorized_info: data?.max_authorized_info,

        only_authorize: data?.authorize_only,

        email_section,

        kyc_required: data?.use_ekyc,
        kyc_ocr_limit: data?.ekyc_orc_limit,
        kyc_face_matching_limit: data?.ekyc_face_matching_limit,
        kyc_face_matching_ratio: data?.ekyc_face_matching_ratio,
      };

      const res = await createEwaiver(payload);

      console.log("eWaiver create form submit:", payload);
      console.log("eWaiver create res:", res);

      toast.success("Successfully Added");
      navigate(`/ewaiver`);
    } catch (error) {
      console.error(`Create e-waiver failed:`, error);
    }
  };

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Add New eWaiver" />

      <EwaiverForm
        defaultValues={null}
        loading={loading}
        onFormSubmit={handleSubmit}
      />
    </div>
  );
};

export default EwaiverCreatePage;
